module.exports = __webpack_public_path__ + "img/male_icon_white.349693fa.svg";